import React from 'react'
import Sidebar from '../organisms/Sidebar'
import Header from '../organisms/Header'
import Footer from '../organisms/Footer'
import { SeoHead } from '../seo/SeoHead'
import './HomeTemplate.css'

const HomeTemplate = ({
  children,
  tools = [],
  path = '/',
  className = '',
  ...props
}) => {
  const classes = [
    'home-template',
    className
  ].filter(Boolean).join(' ')

  return (
    <div className={classes} {...props}>
      <SeoHead path={path} />
      <Sidebar tools={tools} />
      <main className="home-template-main">
        <Header
          title="EveryKits"
          subtitle="Your Digital Utility Belt"
        />
        <div className="home-template-content">
          {children}
        </div>
        <Footer />
      </main>
    </div>
  )
}

export default HomeTemplate